/**
 * @file 配置控制
 * @author mengchen <mengchen@babytree-inc.com>
 */

const hostConfig = (type, num, env) => {
  const config = {
    go: {
      online: '//go.babytree.com/',
      pre: '//go.pre.fpm.babytree.com/',
      // test: `//go.mengqihua.babytree-dev.com`,
      test: `//go.${num || 1}.babytree-test.com/`,
      local: `//go.${num || 1}.babytree-test.com/`
      // local: `//go.mengqihua.babytree-dev.com`,
      // local: '//go.babytree.com/'
    },
    php: {
      online: '//api.babytree.com/',
      pre: '//api.pre.fpm.babytree.com/',
      test: `//${num || 21}.babytree-test.com/`,
      local: `//${num || 21}.babytree-test.com/`
    },
    newmapi: {
      online: '//newmapi.babytree.com/',
      pre: '//newmapi.babytree.com/',
      test: '//newmapi.babytree-test.com/',
      local: '//newmapi.babytree-test.com/'
    },
    mapiweb: {
      online: '//mapiweb.babytree.com/',
      pre: '//mapiweb.pre.fpm.babytree.com/',
      test: '//mapiweb.babytree-test.com/',
      local: '//mapiweb.babytree-test.com/'
    },
    webview: {
      online: '//webview.babytree.com/',
      pre: '//pre.fpm.babytree.com/',
      test: '//webview.16.babytree-test.com/',
      local: '//webview.16.babytree-test.com/'
    },
    abtesting: {
      online: '//abtesting.babytree.com/',
      pre: '//abtesting.babytree.com/',
      test: '//abtesting.babytree.com/',
      local: '//abtesting.babytree.com/'
    },
    open: {
      online: '//open.babytree.com/',
      pre: '//open.21.babytree-test.com/',
      test: '//open.21.babytree-test.com/',
      local: '//open.21.babytree-test.com/'
    },
    bsp: {
      online: '//bsp.babytree.com/',
      pre: '//bsp.21.babytree-test.com/',
      test: '//bsp.21.babytree-test.com/',
      local: '//bsp.21.babytree-test.com/'
    },
    meitun: {
      online: '//m.meitun.com/',
      pre: '//m.meitun-test.com/',
      test: '//m.meitun-test.com/',
      local: '//m.meitun-test.com/'
      // local: '//m.meitun.com/',
    },
    balsa: {
      online: '//balsa-api.babytree.com',
      pre: '//balsa-api.babytree.com',
      test: '//balsa-api.babytree.com',
      local: '//balsa-api.babytree.com'
      // local: '//m.meitun.com/',
    }
  };

  return config[type][env];
};

const getHostEnv = function () {
  const { host } = location;
  if (host == 'h5.babytree.com') {
    return 'online';
  }
  // pre
  if (host.indexOf('pre.fpm') > -1) {
    return 'pre';
  }
  // test
  if (host.indexOf('-test') > -1) {
    return 'test';
  }
  return 'local';
};

export const processEnv = {
  nodeEnv: process.env.NODE_ENV,
  buildVersion: process.env.BUILD_VERSION,
  hostEnv: getHostEnv()
};

export const getStorePrefix = function () {
  return '@@babytree-preg-';
};

export function getHost(type = 'go', num = '1') {
  // return hostConfig[type][processEnv.hostEnv];
  return hostConfig(type, num, processEnv.hostEnv);
}

export function getMeitunHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//m.meitun.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//m.meitun-test.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//m.meitun-test.com/';
  }

  // local
  return '//m.meitun-test.com/';
}
export function getBspHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//bsp.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//bsp.20.babytree-test.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//bsp.20.babytree-test.com/';
  }
  // local
  return '//bsp.hegeng.babytree-dev.com/';
}
/**
 *
 * https://h5-1.babytree-test.com/h5_fe_tool/html/cando/index?
 * &client-baby-status=3
 * &enc-user-id=u194066745079
 * &idfa=BB7D9758-A393-488A-A6BA-B5C61C87AD68&babytree-app-id=pregnancy
 * &babytree-client-type=ios
 * &babytree-app-version=8.26.0
 * &babytree-app-mac=206f56d31cb57206776dda09f74a4df0fc59276b
 * &babytree-app-longitude=116.462216
 * &babytree-app-latitude=39.928028
 * &bpreg_brithday=2016-05-24
 * &bpreg-brithday=2016-05-24
 * &client-role=1¤t-baby-id=95312565
 * &babytree-app-imei=863454034143540
 */

export const QUERY_KEY_WHITE_MAP = {
  'babytree-app-id': 1,
  'babytree-app-latitude': 1,
  'babytree-app-longitude': 1,
  'babytree-app-mac': 1,
  'babytree-app-version': 1,
  'babytree-client-type': 1,
  'bpreg-brithday': 1,
  bpreg_brithday: 1,
  'client-baby-status': 1,
  prepare_status: 1,
  'client-role': 1,
  'enc-user-id': 1,
  'babytree-app-device-model': 1,
  'current-baby-id': 1,
  'android-id': 1,
  'babytree-app-imei': 1,
  idfa: 1,
  moblie_share_src: 1,
  share_pregst: 1,
  share_dest: 1,
  share_ts: 1,
  share_uid: 1,
  share_bd: 1,
  navigation_bar_hidden: 1,
  tcode: 1
};

export const NEWVIEW_QUERY_KEY_WHITE_MAP = {
  navigation_bar_hidden: 1
};

export const NEW_WEBVIEW_QUERY = 'babytree-fe-webview';

window.__processEnv = processEnv;
